<template>
  <v-container fluid class="monitorSite px-2">
    <!-- Breadcrumbs -->
    <v-row>
      <v-col xs="12" center class="pt-0 pb-2">
        <h1>Data Collection Status</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" xs="12" class="pt-1 pb-3">
        <div class="breadcrumbs">
          <a class="crumb-start" @click="onBreadcrumbClicked(-1)">All Agencies</a>
          <a
            class="crumb"
            v-for="(link, index) in links"
            :key="index"
            @click="onBreadcrumbClicked(index)"
            :style="{'z-index': 3 - index}"
          >
            <span :class="`type-img img-level-${index}`"></span>
            {{ link.label }}
          </a>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <!-- LEFT SIDE: STATUS COUNTS -->
      <v-col cols="12" xs="12" md="5" class="pt-1">
        <h2>
          Data Collection Status of
          <span v-if="depth===0">All Agencies</span>
          <!-- :class="`depth${fieldDepth}`" -->
          <span v-else>
            <span :class="`type-img img-level-${parentOfficeDepth}`"></span>{{parentName}}
          </span>
        </h2>
        <div class="grid-caption my-2">Select a row to view the list of offices with this status.</div>
        <ag-grid-vue
          style="width: 100%; height: 240px"
          class="ag-theme-balham elevation-2"
          :columnDefs="statsColumnDefs"
          :rowData="stats"
          @rowClicked="onStatsRowDoubleClicked"
        ></ag-grid-vue>
      </v-col>

      <!-- RIGHT SIDE: OFFICE LIST -->
      <v-col cols="12" xs="12" md="7" class="office-list elevation-2">
        <h2 id="officeListTitle" :class="`depth-${subOfficeDepth}`">
          <span :class="`type-img img-level-${this.depth}`"></span>
          {{ officeCount }}
          {{ subOfficeType }}
          {{ reportTypeString }}
        </h2>
        <div class="grid-caption my-2">Double click a row to view the status of its children.</div>
        <ag-grid-vue
          style="width: 100%; height: 500px; min-height: 500px;"
          class="ag-theme-balham"
          :columnDefs="officeColumnDefs"
          :rowData="offices"
          @rowDoubleClicked="onOfficeRowDoubleClicked"
          :context="context"
        ></ag-grid-vue>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import { adminDataCollectionService } from "@/services/adminDataCollectionService.js";
import router from "@/router";
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "DataCollectionStatsContainer",
  components: {
    AgGridVue
  },
  data: () => ({
    depth: 0,
    officeId: null,
    reportType: null,
    stats: null,
    offices: [],
    links: [],
    context: null,
    statsColumnDefs: [
      {
        headerName: "AGENCY DATA",
        field: "officeData",
        sortable: true,
        resizable: true,
        flex: 3,
        cellClass: "text-left"
      },
      {
        headerName: "Number",
        field: "number",
        sortable: true,
        resizable: true,
        flex: 1
      },
      {
        headerName: "Percentage",
        field: "percentage",
        sortable: true,
        resizable: true,
        flex: 1
      }
    ],
    officeColumnDefs: [
      {
        headerName: "Office Name",
        field: "officeName",
        sortable: true,
        resizable: true,
        flex: 3,
        cellClass: "text-left font-weight-medium"
      },
       {
        headerName: "Abbreviation",
        field: "officeAbbreviation",
        sortable: true,
        resizable: true,
        flex: 1,
        cellClass: "text-left"
      },
      {
        headerName: "Parent Office Name",
        field: "parent",
        sortable: true,
        resizable: true,
        flex: 2,
        cellClass: "text-left"
      },
       {
        headerName: "Last Updated By",
        field: "lastUpdateBy",
        sortable: true,
        resizable: true,
        flex: 1,
        cellClass: "text-left"
      },
      {
        headerName: "Last Modified Date",
        field: "lastUpdateDate",
        sortable: true,
        resizable: true,
        flex: 2,
        cellClass: "text-left"
      },
      {
        headerName: "View Office",
        field: "officeId",
        sortable: false,
        resizable: false,
        flex: 1,
        cellRenderer: params => {
          const route = {
            name: "details",
            params: { id: params.value }
          };

          const link = document.createElement("a");
          let router = params.context.componentParent._routerRoot._router;
          link.innerText = "View office";
          link.addEventListener("click", e => {
            e.preventDefault();
            router.push(route);
          });
          return link;
        }
      }
    ],
    statuses: [
      "not logged into the system",
      "logged into the system without saving data",
      "submission in process",
      "ready to submit",
      "submitted final data",
      "total"
    ]
  }),
  computed: {
    parentName: function () {
      return !this.links || this.links.length === 0
        ? "All Agencies"
        : this.links[this.links.length - 1].label;
    },
    reportTypeString: function () {
      return this.statuses[this.reportType];
    },
    officeCount: function () {
      return !this.offices || this.offices.length === 0
        ? 0
        : this.offices.length;
    },
    subOfficeType: function () {
      switch (this.depth) {
        case 1:
          return "Programs";
        case 2:
          return "Field offices";
        case 3:
          return "Branch offices";
        default:
          return "Agencies";
      }
    },
    subOfficeDepth: function () {
      return this.depth;
    },
    parentOfficeDepth: function () {
      return this.depth - 1;
    }
  },
  methods: {
    onTest: function (id) {
      let e = id;
    },
    onBreadcrumbClicked: function (idx) {
      if (idx === -1) {
        this.links = [];
        this.depth = 0;
        this.reportType = 0;
        this.officeId = null;
        this.loadStatsBasedOnOfficeDepth(this.depth);
        this.onLoadOfficeListAtDepthForReport(this.depth, this.reportType);
        return;
      }

      if (idx < this.links.length - 1) {
        const len = this.links.length - 1 - idx;
        this.links.splice(idx + 1, len);
        this.officeId = this.links[idx].value;
        this.depth = this.links[idx].depth;
        this.onLoadDataCollectionStatsForOffice(this.officeId, this.reportType);
      }
    },
    updateBreadcrumbs: function (data) {
      Vue.set(this.links, this.links.length, {
        label: data.officeName,
        value: data.officeId,
        depth: this.depth
      });
    },
    onOfficeRowDoubleClicked: function (evt) {
      debugger;
      //if (this.depth === 1) return; // Just return if we are at branch level
      const id = evt.data.officeId;
      console.log("Office ID: " + id);
      this.updateBreadcrumbs(evt.data);
      this.onLoadDataCollectionStatsForOffice(id, this.reportType);
    },
    onStatsRowDoubleClicked: function (evt) {
      debugger;
      let reportType = evt.data.id;
      if (reportType === undefined) {
        // hack , undefined = total row
        reportType = 5; // const for total - talk to DD about right way to do this (WIP)
      }

      // Update columns based on the type of report
      let temp = this.officeColumnDefs.splice(0, 6);
      if (reportType === 4) { // Submitted survey reports
        temp[3].headerName = "Last Submitted By";
        temp[4].headerName = "Last Submitted Date";
      } else { // everything else
        temp[3].headerName = "Last Modified By";
        temp[4].headerName = "Last Modified Date";
      }

      // readd columns here
      let idx = 0;
      temp.forEach(val => {
        Vue.set(this.officeColumnDefs, idx++, val);
      });

      console.log("Report type: " + reportType);
      if (this.officeId) {
        this.onLoadOfficeListAtIdForReport(this.officeId, reportType);
      } else {
        this.onLoadOfficeListAtDepthForReport(this.depth, reportType);
      }
    },
    onLoadDataCollectionStatsForOffice: function (id) {
      let me = this;
      me.officeId = id;
      me.depth += 1;
      adminDataCollectionService
        .getDataCollectionStatsForOffice(me.officeId)
        .then(function (resp) {
          me.stats = [];
          let finalRow;
          if (resp.data[5].id === 5) {
            let tmp = resp.data.splice(5, 1);
            finalRow = tmp[0];
          }
          me.stats = resp.data;
          me.stats.push({
            officeData: "Total",
            number: finalRow.number,
            percentage: "100%"
          });

          me.onLoadOfficeListAtIdForReport(me.officeId, me.reportType);
        })
        .catch(function (err) {
          console.error(err);
        });
    },
    onOfficeDepthUpdated: function (type) {
      let me = this;
      me.reportType = type;
      me.offices = [];
      adminDataCollectionService
        .getDataCollectionStatsReportAtDepth(me.reportType, me.officeId)
        .then(function (resp) {
          resp.data.forEach(office => {
            me.offices.push(office);
          });
        })
        .catch(function (err) {
          console.error(err);
        });
    },
    onLoadOfficeListAtDepthForReport: function (depth, reportType) {
      let me = this;
      me.depth = depth;
      me.reportType = reportType;
      adminDataCollectionService
        .getOfficeListAtDepthForReport(me.depth, me.reportType)
        .then(function (resp) {
          me.offices = [];
          resp.data.forEach(office => {
            me.offices.push(office);
          });
        })
        .catch(function (err) {
          console.error(err);
        });
    },
    loadStatsBasedOnOfficeDepth: function (depth) {
      let me = this;
      me.depth = depth;
      adminDataCollectionService
        .getDataCollectionStats(depth)
        .then(function (resp) {
          let finalRow;
          if (resp.data[5].id === 5) {
            let tmp = resp.data.splice(5, 1);
            finalRow = tmp[0];
          }
          me.stats = resp.data;
          me.stats.push({
            officeData: "Total",
            number: finalRow.number,
            percentage: "100%"
          });
        })
        .catch(function (err) {
          console.error(err);
        });
    },
    onLoadOfficeListAtIdForReport: function (id, type) {
      let me = this;
      me.officeId = id;
      me.reportType = type;
      adminDataCollectionService
        .getOfficeListAtIdForReport(me.officeId, me.reportType)
        .then(function (resp) {
          me.offices = [];
          resp.data.forEach(office => {
            office.parent = me.parentName;
            me.offices.push(office);
          });
        })
        .catch(function (err) {
          console.error(err);
        });
    }
  },
  created () {
    if (this.$route.params.type || this.$route.params.type === 0) {
      this.reportType = this.$route.params.type;
    }

    this.depth = 0;
    this.loadStatsBasedOnOfficeDepth(0);
    this.onLoadOfficeListAtDepthForReport(0, this.reportType);

    this.context = { componentParent: this };
  }
};
</script>

<style scoped>
.breadcrumbs span {
  color: dimgray;
  padding-left: 10px;
  padding-right: 10px;
}

.text-left {
  text-align: right;
}

.type-img {
  background-size: 26px;
  background-repeat: no-repeat;
  display: inline-block;
  width: 26px;
  height: 26px;
  vertical-align: bottom;
}

.img-level-0 {
  background-image: url(../../assets/agency.png);
}
.img-level-1 {
  background-image: url(../../assets/program.png);
}
.img-level-2 {
  background-image: url(../../assets/field.png);
}
.img-level-3 {
  background-image: url(../../assets/branch.png);
}
.crumb,
.crumb-start {
  display: block;
  float: left;
  height: 30px;
  background: #0f5182;
  text-align: center;
  padding: 4px 15px 0 22px;
  position: relative;
  margin: 0 10px 8px 0;
  font-size: 14px;
  text-decoration: none;
  color: #fff;
}

.crumb .type-img {
  background-size: 20px;
  width: 20px;
  height: 20px;
}

.crumb:hover,
.crumb-start:hover {
  background: #ff9900;
  color: #0f5182;
}
.crumb-start {
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
  /* padding-top: 8px; */
  z-index: 4;
}
.crumb:before {
  content: "";
  border-top: 15px solid #0f5182;
  border-bottom: 15px solid #0f5182;
  border-left: 15px solid #d9e2f3;
  position: absolute;
  left: 0;
  top: 0;
}
.crumb:hover:before {
  border-top-color: #ff9900;
  border-bottom-color: #ff9900;
}
.crumb:after,
.crumb-start:after {
  content: "";
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 15px solid #0f5182;
  position: absolute;
  right: -15px;
  top: 0;
}
.crumb:hover:after,
.crumb-start:hover:after {
  border-left: 15px solid #ff9900;
}

h2 span.type-img {
  margin-left: 5px;
  margin-right: 3px;
}

.office-list .type-img {
  margin-left: 0;
  margin-right: 15px;
}

</style>
